import { ChatEvaluationTestExecutionResultMetrics, ChatEvaluationTestExecutionResult, TokenUsageDataWithModel } from "@/API";
import { aggregateDurations, formatDurationSec } from "./evaluationReportUtils";

export type MetricFilterType = "all" | "any" | "nv_accuracy" | "nv_context_relevance" | "nv_response_groundedness";
export type MetricAggregationType = "avg" | "max" | "min";

export { formatDurationSec };

export function getAggregatedDurations(
    executionResults?: ChatEvaluationTestExecutionResult[],
    mode: MetricAggregationType | number | "default" = "avg"
): { chatDurationMs: number | null; evaluationDurationMs: number | null } {
    return aggregateDurations(executionResults, mode);
}

export function getAggregatedMetrics(
    executionResults?: ChatEvaluationTestExecutionResult[],
    mode: MetricAggregationType = "avg"
): ChatEvaluationTestExecutionResultMetrics {
    if (!executionResults || executionResults.length === 0) return {};

    const metricValues: Record<string, number[]> = {};

    executionResults.forEach((run) => {
        if (!run.metrics) return;
        Object.entries(run.metrics).forEach(([key, metric]) => {
            if (metric?.score != null && !Number.isNaN(metric.score)) {
                if (!metricValues[key]) {
                    metricValues[key] = [];
                }
                metricValues[key].push(metric.score);
            }
        });
    });

    const result: ChatEvaluationTestExecutionResultMetrics = {};
    Object.entries(metricValues).forEach(([key, scores]) => {
        if (scores.length > 0) {
            if (mode === "max") {
                result[key] = { score: Math.max(...scores) };
            } else if (mode === "min") {
                result[key] = { score: Math.min(...scores) };
            } else {
                const sum = scores.reduce((a, b) => a + b, 0);
                result[key] = { score: sum / scores.length };
            }
        }
    });

    return result;
}

export function getAggregatedTokenUsages(executionResults?: ChatEvaluationTestExecutionResult[]) {
    const chatTokenUsage: TokenUsageDataWithModel[] = [];
    const evaluationTokenUsage: TokenUsageDataWithModel[] = [];

    executionResults?.forEach((run) => {
        if (run.chatTokenUsage) chatTokenUsage.push(...run.chatTokenUsage);
        if (run.evaluationTokenUsage) evaluationTokenUsage.push(...run.evaluationTokenUsage);
    });

    return { chatTokenUsage, evaluationTokenUsage };
}
